import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import AlgorithmForm from "Components/AlgorithmForm/AlgorithmForm";
import Footer from "Components/Footer/Footer";
import Header from "Components/Header/Header";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Styles/bootstrap-custom.min.scss";

ReactDOM.render(
  <React.StrictMode>
    <Header></Header>
    <div id="inner-container" className="container-fluid pt-4 mt-4" style={{ maxWidth: "1000px" }}>
      <AlgorithmForm></AlgorithmForm>
    </div>
    <Footer></Footer>
  </React.StrictMode>,
  document.getElementById("app")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
